import React, { useContext } from "react";
import Toast from "@nykaa/ui-components/Toast";
import Button from "@nykaa/ui-components/Button";
import { trackCheckButtonClickOnToast } from "layouts/Payment/common/dependencies/tracking";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { CommonContextContext } from "wrapper/CommonWrapper/context";

/**
 *
 * @description DeliveryToast component is to show toaster on the checkout page whenever the address is changed by the user or new address is addded with updated delivery dates
 * is rendered on the basis of the state and isToastVisible condition
 * we are doing AB2 experiment for men
 */
interface DeliveryToastProps {
  isToastVisible?: boolean;
  addressIdNotSame?: string;
  toastDeliveryMessage: string;
  setIsCheckButtonClickedOnToast: React.Dispatch<React.SetStateAction<boolean>>;
  setIsScrollToEddElement: React.Dispatch<React.SetStateAction<boolean>>;
  setIsToastVisible: React.Dispatch<React.SetStateAction<boolean>>;
  cartErrorMessage?: string;
}
export const DeliveryToast = (props: DeliveryToastProps) => {
  const {
    addressIdNotSame,
    isToastVisible,
    toastDeliveryMessage,
    setIsCheckButtonClickedOnToast,
    setIsScrollToEddElement,
    setIsToastVisible,
    cartErrorMessage,
  } = props;
  const { cartInfo } = useContext(CommonContextContext);
  const { EDD } = useContext(ExperimentAndSwitchContext);
  const isVisible = addressIdNotSame && isToastVisible && !cartErrorMessage;

  if (
    EDD?.switchEnabled &&
    cartInfo?.cartItems?.some((item: { eddMessage: string }) => item?.eddMessage) &&
    isVisible
  ) {
    return (
      <div className="layout vertical mrl20">
        <Toast
          hideTimer={true}
          message={toastDeliveryMessage}
          onDismiss={() => {}}
          variant="single"
          verticalOffset={16}
          isChildren={true}
        >
          <Button
            kind="tertiary"
            onClick={() => {
              setIsCheckButtonClickedOnToast(true);
              setIsScrollToEddElement(true);
              setIsToastVisible(false);
              trackCheckButtonClickOnToast();
            }}
            shape="default"
            size="small"
          >
            {" "}
            Check
          </Button>
        </Toast>
      </div>
    );
  }
  return null;
};
